// extracted by mini-css-extract-plugin
module.exports = {"iconBadge":"BasketButton_iconBadge__LG6Z5","buttonPadding":"BasketButton_buttonPadding__Qvhp9"};